import React from 'react';
import { graphql } from 'gatsby';

import Page from '../components/global/page';
import FranchisingTemplate from '../templates/franchising-template';

export default ({ data }) => {
	return (
		<Page title={data.copy.title}>
			<FranchisingTemplate copy={data.copy} />
		</Page>
	);
};

export const FranchisingQuery = graphql`
	{
		copy: pagesJson(page: { eq: "franchising" }) {
			title
			content {
				title
				top
				img {
					alt
					src
				}
				content2
				content1
			}
			faq {
				questionsLeft {
					answer
					question
				}
				questionsRight {
					question
					answer
				}
				top
				title
			}
			form {
				top
				title
				copy
			}
		}
	}
`;
